import "../../index19.css";
import { jsxs as a, jsx as i, Fragment as re } from "react/jsx-runtime";
import { useMemo as ae } from "react";
import { a as o, i as se } from "../../core-DVmjA3_O.js";
import { _ as M } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import ce from "../BlockView/index.js";
import de from "../DefaultMessage/index.js";
import he from "../Description/index.js";
import le from "../Heading/index.js";
import N from "../InlineView/index.js";
import s from "../ListView/index.js";
import we from "../../hooks/useSpacingToken.js";
import { getSpacingValue as pe, paddingSpacings as fe } from "../../utils/style.js";
const ge = "_container_1kpe2_1", me = "_with-centered-content_1kpe2_2", _e = "_with-fixed-height_1kpe2_8", ke = "_with-shadow_1kpe2_13", ue = "_with-background_1kpe2_17", Ce = "_with-dark-background_1kpe2_22", ve = "_content_1kpe2_27", Oe = "_pending-overlaid_1kpe2_32", Be = "_message_1kpe2_37", Se = "_with-overflow_1kpe2_42", He = "_with-padding-overflow_1kpe2_43", De = "_overflow-container_1kpe2_50", ye = "_filters_1kpe2_57", xe = "_with-content-well_1kpe2_62", e = {
  container: ge,
  withCenteredContent: me,
  withFixedHeight: _e,
  withShadow: ke,
  withBackground: ue,
  withDarkBackground: Ce,
  content: ve,
  pendingOverlaid: Oe,
  message: Be,
  withOverflow: Se,
  withPaddingOverflow: He,
  overflowContainer: De,
  filters: ye,
  withContentWell: xe
};
function $e(b) {
  const {
    className: P,
    elementRef: W,
    heading: u,
    withEllipsizedHeading: V,
    headingLevel: c = 3,
    headerIcons: C,
    headerActions: d,
    headerDescription: h,
    withHeaderBorder: A,
    withCenteredHeading: L,
    withCenteredHeaderDescription: j,
    withoutWrapInHeader: v,
    withLargeBreakpointInHeader: O,
    filters: l,
    footerIcons: B,
    footer: S,
    footerActions: H,
    withFooterBorder: z,
    withoutWrapInFooter: E,
    children: w,
    withContentOverflow: p,
    withContentWell: D,
    empty: f = !1,
    filtered: y = !1,
    pending: g = !1,
    overlayPending: m,
    errored: _ = !1,
    emptyMessage: R,
    filteredEmptyMessage: $,
    pendingMessage: G,
    errorMessage: T,
    withoutMessageIcon: q,
    withCompactMessage: J,
    withBackground: K,
    withDarkBackground: Q,
    withShadow: U,
    withPadding: k,
    withFixedHeight: X,
    spacing: t,
    spacingOffset: n = 0,
    withoutSpacingOpticalCorrection: r,
    withCenteredContent: Y,
    ...Z
  } = b, x = o(u) || o(C) || o(d), ee = x || o(h), te = o(S) || o(B) || o(H), ne = we({
    spacing: t,
    offset: n,
    modes: fe,
    withoutOpticalCorrection: r
  }), F = pe(t, n), ie = p && k ? /* @__PURE__ */ i(
    "div",
    {
      className: e.overflowContainer,
      style: {
        padding: `0 ${F}`,
        margin: `0 calc(-1 * ${F})`
      },
      children: w
    }
  ) : w, I = (w || f || g || _ || y) && /* @__PURE__ */ a(re, { children: [
    /* @__PURE__ */ i(
      de,
      {
        className: e.message,
        pending: g,
        filtered: y,
        errored: _,
        empty: f,
        overlayPending: m,
        emptyMessage: R,
        filteredEmptyMessage: $,
        pendingMessage: G,
        errorMessage: T,
        withoutIcon: q,
        compact: J
      }
    ),
    !f && !_ && (!g || m) && ie
  ] }), oe = ae(() => v ? "none" : c > 3 ? "sm" : O ? "lg" : "md", [c, O, v]);
  return /* @__PURE__ */ a(
    ce,
    {
      ...Z,
      elementRef: W,
      className: M(
        e.container,
        K && e.withBackground,
        Q && e.withDarkBackground,
        U && e.withShadow,
        D && e.withContentWell,
        X && e.withFixedHeight,
        Y && e.withCenteredContent,
        P
      ),
      spacing: t,
      spacingOffset: n,
      withoutSpacingOpticalCorrection: r,
      withPadding: k,
      before: ee && /* @__PURE__ */ a(
        s,
        {
          spacing: t,
          spacingOffset: n,
          layout: "block",
          withSpacingOpticalCorrection: !0,
          children: [
            x && /* @__PURE__ */ i(
              N,
              {
                spacing: t,
                spacingOffset: n - 1,
                withoutSpacingOpticalCorrection: r,
                wrapBreakpoint: oe,
                before: C,
                after: d && /* @__PURE__ */ i(
                  s,
                  {
                    spacing: t,
                    spacingOffset: n - 1,
                    withSpacingOpticalCorrection: !r,
                    children: d
                  }
                ),
                children: /* @__PURE__ */ i(
                  le,
                  {
                    level: c,
                    ellipsize: V,
                    centerAligned: L,
                    children: u
                  }
                )
              }
            ),
            h && /* @__PURE__ */ i(he, { withCenteredContent: j, children: h })
          ]
        }
      ),
      after: te && /* @__PURE__ */ i(
        N,
        {
          spacing: t,
          spacingOffset: n,
          withoutSpacingOpticalCorrection: r,
          before: B,
          after: H,
          wrapBreakpoint: E ? "none" : "lg",
          children: S
        }
      ),
      withBeforeSeparator: A,
      withAfterSeparator: z,
      childrenContainerClassName: M(
        e.content,
        m && e.pendingOverlaid,
        p && e.withOverflow,
        k && p && e.withPaddingOverflow,
        D && ne
      ),
      children: [
        o(l) && /* @__PURE__ */ a(
          s,
          {
            layout: "block",
            spacing: t,
            spacingOffset: n,
            children: [
              /* @__PURE__ */ i(
                s,
                {
                  gridContentClassName: e.filters,
                  layout: "grid",
                  numPreferredGridColumns: 6,
                  spacing: t,
                  spacingOffset: n - 1,
                  children: l
                }
              ),
              I
            ]
          }
        ),
        se(l) && I
      ]
    }
  );
}
export {
  $e as default
};
